import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ['modals','modal','toInvalidModal','toActiveModal']

    openModal(event){
        const modals = this.modalsTarget;
        const modal = modals.querySelector('#'+ event.params.name + 'Modal');
        modal.setAttribute("style", "display: block;")
    }
    closeModal(event){
        const modals = this.modalsTarget;
        const modal = modals.querySelector('#'+ event.params.name + 'Modal');
        modal.setAttribute("style", "display: none;")
    }
}
